import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthSigninRegisterComponent } from './auth-signin-register/auth-signin-register.component';
import { AuthGuard } from '../../_helpers/auth.guard';

export enum AuthPaths {
  signIn = "signin",
  register = "register"
}

const routes: Routes = [
  { path: AuthPaths.signIn, component: AuthSigninRegisterComponent },
  { path: AuthPaths.register, component: AuthSigninRegisterComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }